import React from "react";
import PropTypes from "prop-types";
const FacebookIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <path
      fillRule="nonzero"
      d="M15.115 0c.49 0 .885.396.885.885v14.23c0 .49-.396.885-.885.885h-4.073V9.802h2.073l.312-2.417h-2.385V5.844c0-.698.187-1.167 1.198-1.167l1.27-.01V2.51c-.218-.03-.979-.093-1.854-.093-1.844 0-3.114 1.125-3.114 3.187v1.781H6.458v2.417h2.084V16H.885A.885.885 0 0 1 0 15.115V.885C0 .395.396 0 .885 0h14.23z"
    />
  </svg>
);
FacebookIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default FacebookIcon;
